import type { Genome, AlchemyType } from '@/domain/genetics/types';
import { elementCombatIcon, type CombatIconId } from './combat-icons';

export type CombatEffectLayer = 'flame' | 'wave' | 'stone' | 'wind-streak' | 'leaf' | 'shadow-smoke';
export interface CombatVisualProfile {
  primaryIcon: CombatIconId;
  secondaryBadges: readonly CombatIconId[];
  effectLayers: readonly CombatEffectLayer[];
  accentHues: readonly number[];
  impactScale: number;
  ornament: 'none' | 'horned' | 'tailed' | 'marked';
}

const LAYER: Record<AlchemyType, CombatEffectLayer> = {
  Fire: 'flame', Water: 'wave', Earth: 'stone', Air: 'wind-streak', Life: 'leaf', Shadow: 'shadow-smoke',
};
const HUE: Record<AlchemyType, number> = { Fire: 12, Water: 202, Earth: 34, Air: 184, Life: 112, Shadow: 270 };

export function deriveCombatVisualProfile(genome: Genome): CombatVisualProfile {
  const types = [...new Set(genome.primaryTypes)].slice(0, 3);
  const primary = types[0] ?? 'Fire';
  const ornament = genome.horns !== 'none' ? 'horned' : genome.tail !== 'none' ? 'tailed' : genome.markings !== 'none' ? 'marked' : 'none';
  return {
    primaryIcon: elementCombatIcon(primary),
    secondaryBadges: types.slice(1).map(elementCombatIcon),
    effectLayers: types.map((type) => LAYER[type]),
    accentHues: types.map((type) => HUE[type]),
    impactScale: 1,
    ornament,
  };
}
